import styled from 'styled-components'

export const BackArrow = styled.img`
    width:28px;
    height:28px;
    margin-left:10px;
    margin-right:20px;
    cursor: pointer;
`;